import { useTranslation } from 'react-i18next';
import { Variant } from '@components/badge/src/badge.type';

import { AdmissionCardInfoProps, STATUS_TRANSLATION_KEYS, STATUS_VARIANT } from '../src/admission-card.type';

import { AdmissionCardBadges } from './admission-card-badges';
import { AdmissionCardDescription } from './admission-card-description';
import { AdmissionCardInteractive } from './admission-card-interactive';

export const AdmissionCardInfo = ({
  id,
  status,
  checked,
  listeners,
  attributes,
  isDragActive = false,
  isSelectActive,
  isMultiSelectActive,
  onChange,
  cardOpacity,
  color,
  name,
  tags,
  accessValidity,
  locale,
  guestCapacity,
  soldItems,
  quantity,
  description,
  isDateVisible,
  onlinePrice,
  ddpPrice,
  formattedSalesEndsDate,
  formattedOnlinePrice,
  formatedDdpPrice,
}: AdmissionCardInfoProps) => {
  const { t } = useTranslation();
  const badgeVariant = status ? (STATUS_VARIANT[status] as Variant) : '';
  const statusTranslated = status ? t(STATUS_TRANSLATION_KEYS[status]) : '';

  return (
    <>
      <div className='hidden sm:flex'>
        <AdmissionCardInteractive
          id={id}
          checked={checked}
          isDragActive={isDragActive}
          isSelectActive={isSelectActive}
          isMultiSelectActive={isMultiSelectActive}
          listeners={listeners}
          attributes={attributes}
          onChange={onChange}
        />
      </div>
      <div className={`flex flex-col ${cardOpacity} w-full min-w-0 gap-2`}>
        <div className='flex flex-row items-start sm:items-center mt-1 sm:mt-0 gap-1.5 sm:gap-2 min-w-0'>
          <div className='flex sm:hidden'>
            <AdmissionCardInteractive
              id={id}
              checked={checked}
              isDragActive={isDragActive}
              isSelectActive={isSelectActive}
              isMultiSelectActive={isMultiSelectActive}
              listeners={listeners}
              attributes={attributes}
              onChange={onChange}
            />
          </div>
          {color && (
            <div className='w-3 h-3 rounded-full shrink-0 mt-1 sm:mt-0' style={{ backgroundColor: `${color}` }}></div>
          )}
          <span
            data-testid='admission-card--name'
            className='text-left text-subtitle-m text-primary line-clamp-2 sm:line-clamp-1 min-w-0'>
            {name}
          </span>
        </div>
        <AdmissionCardDescription
          description={description}
          isDateVisible={isDateVisible}
          onlinePrice={onlinePrice}
          ddpPrice={ddpPrice}
          formattedSalesEndsDate={formattedSalesEndsDate}
          formattedOnlinePrice={formattedOnlinePrice}
          formatedDdpPrice={formatedDdpPrice}
        />
        <AdmissionCardBadges
          {...{
            status,
            badgeVariant,
            statusTranslated,
            tags,
            accessValidity,
            locale,
            guestCapacity,
            cardOpacity,
            soldItems,
            quantity,
            t,
          }}
        />
      </div>
    </>
  );
};
